export default {
  name: 'player-setup-license-icon',
  props: {
    license: {
      type: String,
      default: ''
    }
  }
}
